import { defineNuxtPlugin } from '#app';
import bootstrapDropdown from '~/directives/bootstrapDropdown.js';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive('bootstrap-dropdown', bootstrapDropdown);
});
